/* eslint-disable class-methods-use-this */
import {
  MessageAPI,
  ToastMessage,
} from 'utils/__interfaces/SuperAdministration/Message'

class ToastMessagesNormalizer {
  normalize(toastMessages: MessageAPI[]): ToastMessage[] {
    return toastMessages.map((message) => {
      return {
        id: message.id,
        messagetext: message.messagetext,
      }
    })
  }
}

export default new ToastMessagesNormalizer()
